import React, { Component } from 'react';
import { Container} from 'react-bootstrap';

function AboutPage() {
        return <Container>
            This is About Page!
            More info here watch this space!
            Some more info and bio to go here
        </Container>
}
export default AboutPage;
